









































































import {
  defineComponent,
  computed,
} from '@vue/composition-api';
import {
  NOW,
  NOW_START_YEAR,
  NOW_START_MONTH,
} from '@/utils';

import { useQuery } from '@vue/apollo-composable';

import SmallChartPanel from '@/components/Report/SmallChartPanel.vue';
import TreemapAreaFailedDelivery from '@/components/Report/05-UnsuccessCost/5.1-UnsuccessDelivery/TreemapAreaFailedDelivery.vue';
import DonutHubFailedDelivery from '@/components/Report/05-UnsuccessCost/5.1-UnsuccessDelivery/DonutHubFailedDelivery.vue';
import ChartWithLastYearCompareFailedDelivery from '@/components/Report/05-UnsuccessCost/5.1-UnsuccessDelivery/ChartWithLastYearCompareFailedDelivery.vue';
import ChartWithSelectedMonthFailedDelivery from '@/components/Report/05-UnsuccessCost/5.1-UnsuccessDelivery/ChartWithSelectedMonthFailedDelivery.vue';

import overallExpense from '@/gql/managementReport/02-Expense/overallExpense.gql';
import monthsFailedDeliveryIncome from '@/gql/managementReport/05-UnsuccessCost/5.1-FailedDeliveryCost/monthsFailedDeliveryIncome.gql';
import failedDeliveryIncome from '@/gql/managementReport/05-UnsuccessCost/5.1-FailedDeliveryCost/failedDeliveryIncome.gql';
import failedDeliveryIncomeRange from '@/gql/managementReport/05-UnsuccessCost/5.1-FailedDeliveryCost/failedDeliveryIncomeRange.gql';
import failedDeliveryIncomeByHub from '@/gql/managementReport/05-UnsuccessCost/5.1-FailedDeliveryCost/failedDeliveryIncomeByHub.gql';
import failedDeliveryIncomeByArea from '@/gql/managementReport/05-UnsuccessCost/5.1-FailedDeliveryCost/failedDeliveryIncomeByArea.gql';

const UnsuccessDeliveryCost = defineComponent({
  components: {
    SmallChartPanel,
    ChartWithSelectedMonthFailedDelivery,
    DonutHubFailedDelivery,
    TreemapAreaFailedDelivery,
    ChartWithLastYearCompareFailedDelivery,
  },
  setup() {
    const primaryColor = 'rgba(243,109,39,1)';
    const secondaryColor = 'rgba(255,131,3,1)';

    const { result: getTopInfo } = useQuery(failedDeliveryIncome, computed(() => ({
      timeframe: { from: NOW_START_YEAR, to: NOW },
      timeframeY1: { from: NOW_START_MONTH, to: NOW },
    })));
    const getPanelInfo = computed(() => getTopInfo.value?.failedDeliveryIncome || {});
    const getPanelInfoMtd = computed(() => getTopInfo.value?.failedDeliveryIncomeMTD || {});
    return {
      primaryColor,
      secondaryColor,

      overallExpense,
      monthsFailedDeliveryIncome,
      failedDeliveryIncomeRange,
      failedDeliveryIncomeByHub,
      failedDeliveryIncomeByArea,
      failedDeliveryIncome,

      getPanelInfo,
      getPanelInfoMtd,
    };
  },
});

export default UnsuccessDeliveryCost;
